import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface PortfolioStatsProps {
  stats: {
    totalProjects: number;
    completedProjects: number;
    satisfiedClients: number;
    averageRating: number;
  };
}

const PortfolioStats = ({ stats }: PortfolioStatsProps) => {
  const statItems = [
    {
      icon: 'FolderIcon',
      label: '총 프로젝트',
      value: stats.totalProjects.toString(),
      suffix: '개'
    },
    {
      icon: 'CheckCircleIcon',
      label: '완료된 프로젝트',
      value: stats.completedProjects.toString(),
      suffix: '개'
    },
    {
      icon: 'UserGroupIcon',
      label: '만족한 고객',
      value: stats.satisfiedClients.toString(),
      suffix: '명'
    },
    {
      icon: 'StarIcon',
      label: '평균 평점',
      value: stats.averageRating.toFixed(1),
      suffix: '/5.0'
    }
  ];

  return (
    <div data-component-id="src/app/portfolio/components/PortfolioStats.tsx:42:4" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="42" data-component-file="PortfolioStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-background%20border-b%20border-border%22%7D" className="bg-background border-b border-border">
      <div data-component-id="src/app/portfolio/components/PortfolioStats.tsx:43:6" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="43" data-component-file="PortfolioStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20lg%3Apx-8%20py-12%22%7D" className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div data-component-id="src/app/portfolio/components/PortfolioStats.tsx:44:8" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="44" data-component-file="PortfolioStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20lg%3Agrid-cols-4%20gap-8%22%7D" className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {statItems.map((item, index) => (
            <div data-component-id="src/app/portfolio/components/PortfolioStats.tsx:46:12" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="46" data-component-file="PortfolioStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%22%7D" key={index} className="text-center">
              <div data-component-id="src/app/portfolio/components/PortfolioStats.tsx:47:14" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="47" data-component-file="PortfolioStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mb-3%22%7D" className="flex justify-center mb-3">
                <div data-component-id="src/app/portfolio/components/PortfolioStats.tsx:48:16" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="48" data-component-file="PortfolioStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-12%20h-12%20bg-surface%20border%20border-border%20flex%20items-center%20justify-center%22%7D" className="w-12 h-12 bg-surface border border-border flex items-center justify-center">
                  <Icon data-component-id="src/app/portfolio/components/PortfolioStats.tsx:49:18" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="49" data-component-file="PortfolioStats.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-text-primary%22%7D" name={item.icon as any} size={24} className="text-text-primary" />
                </div>
              </div>
              <div data-component-id="src/app/portfolio/components/PortfolioStats.tsx:52:14" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="52" data-component-file="PortfolioStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-2xl%20font-bold%20text-text-primary%20mb-1%22%7D" className="text-2xl font-bold text-text-primary mb-1">
                {item.value}
                <span data-component-id="src/app/portfolio/components/PortfolioStats.tsx:54:16" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="54" data-component-file="PortfolioStats.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-sm%20font-normal%20text-text-secondary%20ml-1%22%7D" className="text-sm font-normal text-text-secondary ml-1">
                  {item.suffix}
                </span>
              </div>
              <div data-component-id="src/app/portfolio/components/PortfolioStats.tsx:58:14" data-component-path="src/app/portfolio/components/PortfolioStats.tsx" data-component-line="58" data-component-file="PortfolioStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-sm%20text-text-secondary%22%7D" className="text-sm text-text-secondary">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortfolioStats;